import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import logo from "../assets/logo.svg";

const Footer = () => {
  const [showBackToTop, setShowBackToTop] = useState(false);
  useEffect(() => {
    const handleScroll = () => setShowBackToTop(window.scrollY > 300);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  const PLAY_STORE_URL =
    "https://play.google.com/store/apps/details?id=com.vergadonewapp";
  const APP_STORE_URL =
    "https://apps.apple.com/us/app/your-app-name/id6739209149";
  const MUMBAI_MAP_URL =
    "https://www.google.com/maps/search/?api=1&query=11-C%2C+Corporate+Park%2C+Sion+Trombay+Road%2C+Chembur%2C+Mumbai+400071";
  const MOHALI_MAP_URL =
    "https://www.google.com/maps/search/?api=1&query=Vergado%2C+Simson+House%2C+1723%2C+Sector+82%2C+Sahibzada+Ajit+Singh+Nagar%2C+Punjab+140306";

  const handleGetAppClick = (e) => {
    e.preventDefault();

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isAndroid = /Android/.test(navigator.userAgent);

    if (isIOS) {
      window.open(APP_STORE_URL, "_blank");
    } else if (isAndroid) {
      window.open(PLAY_STORE_URL, "_blank");
    } else {
      window.open(PLAY_STORE_URL, "_blank");
    }
  };
  return (
    <>
      <footer id="footer">
        <div className="footer-top dark">
          <div className="container">
            <div className="row justify-content-center">
              <div
                className="col-lg-5 col-md-6 footer-contact"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <h3 className="mb-3">
                  <Link to="/">
                    <img src={logo} alt="Vergado" className="img-fluid" />
                  </Link>
                </h3>
                <p>
                  <b>Corporate Office:</b> 11-C, Corporate Park Sion Trombay
                  Road Chembur, Mumbai 400071 Maharashtra, India <br />
                  <a
                    href={MUMBAI_MAP_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View on Google Maps
                  </a>
                  <br />
                  <b>Development Lab:</b> Vergado, Simson House, 1723, Sector
                  82, Sahibzada Ajit Singh Nagar, Punjab 140306, India
                  <br />
                  <a
                    href={MOHALI_MAP_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View on Google Maps
                  </a>
                  <br />
                  {/* <strong>Phone:</strong> +91 0000000000 */}
                  <br />
                  <strong>Email : </strong>admin@vergado.in
                </p>
              </div>

              <div
                className="col-lg-3 col-md-6 footer-links"
                data-aos="fade-up"
                data-aos-delay="150"
              >
                <h4>Company</h4>
                <ul>
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="/why-vergado">Why Vergado</Link>
                  </li>
                  <li>
                    <Link to="/pricing">Pricing</Link>
                  </li>
                  <li>
                    <Link to="/compare">Compare</Link>
                  </li>
                  <li>
                    <Link to="/blog">Blog</Link>
                  </li>
                  <li>
                    <Link to="/glossary">Glossary</Link>
                  </li>
                  <li>
                    <Link to="/minimum-wages">Minimum Wages</Link>
                  </li>
                  <li>
                    <Link to="/resource">Resources</Link>
                  </li>
                  <li>
                    <Link to="/contact-us">Contact us</Link>
                  </li>
                </ul>
              </div>

              <div
                className="col-lg-2 col-md-6 footer-links"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <h4>Products</h4>
                <ul>
                  <li>
                    <Link to="/products">All Products</Link>
                  </li>
                  <li>
                    <Link to="/products/recruitment">Recruitment</Link>
                  </li>
                  <li>
                    <Link to="/products/onboarding">Onboarding</Link>
                  </li>
                  <li>
                    <Link to="/products/induction-training">
                      Induction Training
                    </Link>
                  </li>
                  <li>
                    <Link to="/products/attendance">Attendance</Link>
                  </li>
                  <li>
                    <Link to="/products/leave-management">
                      Leave Management
                    </Link>
                  </li>
                  <li>
                    <Link to="/products/payroll">Payroll</Link>
                  </li>
                  <li>
                    <Link to="/products/compliance">Compliance</Link>
                  </li>
                  <li>
                    <Link to="/products/expense-management">Expenses</Link>
                  </li>
                  <li>
                    <Link to="/products/vendor-management">
                      Vendor Management
                    </Link>
                  </li>
                  <li>
                    <Link to="/products/cash/advance">Advances</Link>
                  </li>
                  <li>
                    <Link to="/products/asset-management">
                      Asset Management
                    </Link>
                  </li>
                  <li>
                    <Link to="/products/document-builder">
                      Document Builder
                    </Link>
                  </li>
                  <li>
                    <Link to="/products/employee-benefits">Benefits</Link>
                  </li>
                  <li>
                    <Link to="/products/cash/petty">Petty Cash</Link>
                  </li>
                </ul>
              </div>

              <div
                className="col-lg-2 col-md-6 footer-links"
                data-aos="fade-up"
                data-aos-delay="250"
              >
                <h4>Help</h4>
                <ul>
                  <li>
                    <Link to="/faq">FAQ</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy policy</Link>
                  </li>
                  <li>
                    <Link to="/term-and-condition">Terms of service</Link>
                  </li>
                  <li>
                    <Link to="/refund-policy">Refund policy</Link>
                  </li>
                  <li>
                    <a
                      onClick={handleGetAppClick}
                      style={{ cursor: "pointer" }}
                    >
                      Get App
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-brand">Vergado</div>

        <div className="container d-md-flex align-items-center py-2">
          <div className="me-md-auto text-center text-md-start">
            <div className="copyright">
              &copy; Copyright{" "}
              <strong>
                <span>Vergado</span>
              </strong>
              . All Rights Reserved
            </div>
          </div>
          <div className="social-links text-center text-md-right pt-3 pt-md-0">
            {/* <Link href="#" className="twitter">
              <i className="bi bi-twitter-x"></i>
            </Link>
            <Link href="#" className="facebook">
              <i className="bi bi-facebook"></i>
            </Link> */}
            <a
              href="https://www.instagram.com/vergado.io/"
              className="instagram"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="bi bi-instagram"></i>
            </a>
            {/* <Link href="#" className="google-plus">
              <i className="bi bi-skype"></i>
            </Link> */}
            <a
              href="https://in.linkedin.com/company/vergado"
              className="linkedin"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="bi bi-linkedin"></i>
            </a>
          </div>
        </div>
      </footer>

      <button
        type="button"
        onClick={scrollToTop}
        aria-label="Back to top"
        className={`back-to-top d-flex align-items-center justify-content-center border-0 ${
          showBackToTop ? "active" : ""
        }`}
      >
        <i className="bi bi-arrow-up-short"></i>
      </button>
    </>
  );
};

export default Footer;
